var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React from "react";
/** QuiField is a simple wrapper component that can be composed with any Quinine input component (e.g. QuiTextInput, QuiSelect, QuiCheckbox, etc...) to give it standardized labels, helper text, sub-helper text, and validation error messages.
 * This component is not controlled, the typical use should be as a building block to create a controlled field component (e.g. QuiTextField, QuiPasswordField, QuiSelectField, etc...)
 */
export function QuiField(_a) {
    var { label, helperText, subHelperText, className, children, id, showError, errorMessage } = _a, otherProps = __rest(_a, ["label", "helperText", "subHelperText", "className", "children", "id", "showError", "errorMessage"]);
    const fieldGroupClassName = classNames(className, "qui-color-black-900 qui-flex-v-xs qui-field-group");
    return (React.createElement("div", Object.assign({ className: fieldGroupClassName }, otherProps),
        label && (React.createElement("label", { className: "qui-text-sm qui-semibold", htmlFor: id, "data-test": "qui-field-label" }, label)),
        helperText && (React.createElement("span", { className: "qui-text-xs qui-color-black-600", id: `${id}-helper`, "data-test": "qui-field-helpertext" }, helperText)),
        children,
        // error message takes priority over the sub helper text.
        subHelperText && !showError && (React.createElement("span", { className: "qui-text-xs qui-color-black-600", id: `${id}-subhelper`, "data-test": "qui-field-subhelpertext" }, subHelperText)),
        showError && (React.createElement("span", { className: "qui-text-xs qui-color-danger", id: `${id}-error`, "aria-live": "assertive", "data-test": "qui-field-error" }, errorMessage))));
}
